<template>
  <div class="my-1 border-t border-border-subtle" />
</template>

<script lang="ts"></script>
